<mat-radio-group [(ngModel)]="type" (ngModelChange)="onChange($event)" [disabled]="disabled">
  <mat-radio-button value="Edificio">{{ 'LABEL.BUILDING' | translate }}</mat-radio-button>
  <!-- <mat-radio-button value="Privato">Privato</mat-radio-button> -->
  <mat-radio-button value="Amministratore">{{ 'LABEL.ADMIN' | translate }}</mat-radio-button>
  <mat-radio-button value="Condominio">{{ 'LABEL.CONDOMINIUM' | translate }}</mat-radio-button>
  <mat-radio-button value="other">{{ 'LABEL.OTHER_SUBJ_TYPE' | translate }}</mat-radio-button>
</mat-radio-group>
